import React from 'react'

import '../../css/common/KeyList.css'
import '../../css/index.css'

type TRowEmptyProps = {
  colSpan: any
  emptyRowText: string
}

const TRowEmpty = ({ colSpan, emptyRowText }: TRowEmptyProps) => (
  <tr>
    <td colSpan={colSpan}>
      <div className="responsive-font d-flex align-items-center justify-content-center">
        <h6 className="responsive-font">{emptyRowText}</h6>
      </div>
    </td>
  </tr>
)

export default TRowEmpty
